module.exports = __webpack_public_path__ + "static/Benz.9de3da56.png";